import Vue from 'vue';
import router from './router';
import store from './store';
import App from './App';
import filters from './filters';
import LoadingMore from './components/LoadingMore';
import ToggleBtn from './components/ToggleBtn';
import Api from './api/pay';
import config from './config';
import tool from './tools/tool';
Vue.use( tool );


import VConsole from 'vconsole';
if ( process.env.APP_ENV == "dev" ) {
new VConsole();
}


import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import Alert from 'vux/src/components/alert/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import DatetimeRange from 'vux/src/components/datetime-range/index.vue'


import preset from './tools/preset.js';
Vue.prototype.$preset = preset;

Vue.component( 'alert', Alert );
Vue.component( 'Dialog', XDialog );
Vue.component( 'toast', Toast );
Vue.component( 'icon', Icon );
Vue.component( 'group', Group );
Vue.component( 'cell', Cell );
Vue.component( 'grid', Grid );
Vue.component( 'gridItem', GridItem );
Vue.component( 'x-input', XInput );
Vue.component( 'x-button', XButton );
Vue.component( 'selector', Selector );
Vue.component( 'confirm', Confirm );
Vue.component( 'popup', Popup );
Vue.component( 'datetime-range', DatetimeRange );
Vue.use( LoadingPlugin, { position: 'middle' } );
Vue.use( ConfirmPlugin );
Vue.use( ToastPlugin, { position: 'middle', type: 'text', time: 1500, 'is-show-mask': true } );
Vue.use( AjaxPlugin );
Vue.use( WechatPlugin );
Vue.use( filters );


Vue.component( 'v-scroll', LoadingMore );
Vue.component( 'ToggleBtn', ToggleBtn );


router.beforeEach( function ( to, from, next ) {
document.title = to.meta.title;
if ( from.name ) {
let contentElem = document.querySelector( '.scrollYContainer' );
let scrollTop = contentElem ? contentElem.scrollTop : '0';
store.state.common.scrollPos[ from.name ] = scrollTop;
}
next();
} );


router.afterEach( function () {
Vue.$vux.loading.hide();
} );


const setConfig = config;
Vue.http.interceptors.request.use( config => {
config.headers[ 'Content-Type' ] = 'application/json';
config.headers[ 'appId' ] = setConfig.appid;

if ( process.env.APP_ENV == "dev" ) {
config.url = config.url.replace( "/api/", "/api2/" );
}

if ( localStorage.getItem( 'parklotInfo' ) ) {
let parklotInfo = JSON.parse( localStorage.getItem( 'parklotInfo' ) );
config.headers[ 'companyId' ] = parklotInfo.companyId;
} else {
let parklotHref = window.location.href;
if ( parklotHref.indexOf( 'unlicensedQroNew' ) !== -1 ) {
config.headers[ 'companyId' ] = '-';
} else {
if ( window.location.href.indexOf( 'toggleParklot' ) !== -1 ) {
config.headers[ 'companyId' ] = '-';
}
}
}
return config;
}, err => {
return Promise.reject( err );
} );


Vue.http.interceptors.response.use( response => {
if ( response.data.errorCode === '0' ) {
return response.data.result;
}
return response.data;
}, err => {
Vue.$vux.toast.show( { text: '网络异常', type: 'text' } );
return Promise.reject( err );
} );


String.prototype.trim = function () {
return this.replace( /(^\s*)|(\s*$)/g, '' );
};


function loading ( booleran ) {
if ( booleran ) {
var container = document.createElement( "div" );
container.id = "loading";
container.style.position = 'fixed';
container.style.zIndex = 100;
container.style.width = '100%';
container.style.height = '100%';
container.style.top = 0;
container.style.left = 0;
container.style.display = 'flex';
container.style.justifyContent = 'center';
container.style.alignItems = 'center';
var content = document.createElement( "div" );
content.style.width = "70px";
content.style.height = "70px";
content.style.borderRadius = "10px";
content.style.backgroundImage = "url('" + require( "@/assets/images/loading.gif" ) + "')";
content.style.backgroundSize = "100% 100%";
content.style.backgroundPosition = "center center";
content.style.backgroundRepeat = "no-repeat";
container.append( content );
$( "body" ).append( container );
} else {
$( "#loading" ).remove();
}
}


Vue.prototype.$config = config;


Vue.config.productionTip = false;
new Vue( {
router,
store,
render: h => h( App ),
created () {
this.adjustScreen();

if ( this.$router.history.pending.name !== "download" ) {
this.getCode();
}
},
methods: {

openAuthority () {
let href = window.location.href;
let urlParams = href.split( "#/" )[ 1 ];
let url = config.Url + urlParams;
let redirectUri = encodeURIComponent( url );
window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_base#wechat_redirect';
},

getCode () {
let code = tool.getUrlParam( 'code' );
if ( !code ) {
this.openAuthority();
} else {
loading( true );
Api.authorization( { appid: config.appid, code: code } ).then( res => {
loading( false );
let data = res.data;
let openId = data.openId;
this.$store.commit( 'payParams/getPayParams', data );
this.$store.commit( 'payParams/getOpenId', openId );
this.$wechat.config( {
beta: true,
debug: false,
appId: config.appid,
timestamp: data.timestamp,
nonceStr: data.nonceStr, // 随机串
signature: data.signature,
jsApiList: [ 'chooseInvoiceTitle', 'addCard', 'chooseWXPay', 'getNetworkType', 'previewImage', 'openCard',
'translateVoice', 'chooseImage', 'uploadImage', 'onMenuShareTimeline', 'hideOptionMenu', 'hideMenuItems'
]
} );
this.$wechat.ready( function ( res ) {
console.log( "页面加载完成" );



} );
this.$wechat.error( function ( res ) {
console.log( "jsapi异常错误:", res );
console.log( "config参数", {
beta: true,
debug: false,
appId: config.appid,
timestamp: data.timestamp,
nonceStr: data.nonceStr, // 随机串
signature: data.signature,
jsApiList: [ 'chooseInvoiceTitle', 'addCard', 'chooseWXPay', 'getNetworkType', 'previewImage', 'openCard',
'translateVoice', 'chooseImage', 'uploadImage', 'onMenuShareTimeline', 'hideOptionMenu', 'hideMenuItems'
]
} );
} );
} ).catch( err => {
loading( false );
setTimeout( () => {
this.openAuthority();
}, 5000 );

} );
}
},

adjustScreen () {
if ( typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function" ) {
handleFontSize();
} else {
if ( document.addEventListener ) {
document.addEventListener( "WeixinJSBridgeReady", handleFontSize, false );
} else if ( document.attachEvent ) {

document.attachEvent( "onWeixinJSBridgeReady", handleFontSize );
}
}
function handleFontSize () {

WeixinJSBridge.invoke( 'setFontSizeCallback', { 'fontSize': 0 } );

WeixinJSBridge.on( 'menu:setfont', function () {
WeixinJSBridge.invoke( 'setFontSizeCallback', { 'fontSize': 0 } );
} );
}
}
}
} ).$mount( '#app-box' );



// WEBPACK FOOTER //
// ./src/main.js